import { Component, OnInit } from '@angular/core';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {FlowTypeService} from '../../../../../shared/src/lib/services/flow-type.service';

@Component({
  selector: 'app-for-business',
  templateUrl: './for-business.component.html',
  styleUrls: ['./for-business.component.scss']
})
export class ForBusinessComponent implements OnInit {
  apiUrl = environment.apiUrl;

  constructor(
      public auth: AuthService,
      private flowTypeService: FlowTypeService
  ) { }

  ngOnInit(): void {
    this.flowTypeService.state = 'default';
  }

}
